import React, { createContext, useContext, useEffect, useReducer } from "react";
import http from "../Http";
import { AUTH_ENDPOINTS } from "../constants/Endpoints";

const UserContext = createContext(null);

const userReducer = (state, action) => {
  switch (action.type) {
    case "AUTHENTICATED":
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        userInfo: action.userInfo,
      };
    case "NOT_AUTHENTICATED":
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        userInfo: null,
      };
  }
};

const AxiosInterceptor = ({ children }) => {
  const { dispatch } = useUserInfo();

  useEffect(() => {
    http.createInstance(dispatch);
  }, [dispatch]);

  return children;
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, {
    isAuthenticated: false,
    isLoading: true,
    userInfo: null,
  });

  useEffect(() => {
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    try {
      http.createInstance();
      const userResponse = await http.get(AUTH_ENDPOINTS.USER);
      dispatch({ type: "AUTHENTICATED", userInfo: userResponse.data });
    } catch (e) {
      dispatch({ type: "NOT_AUTHENTICATED" });
    }
  };

  return (
    <UserContext.Provider value={{ ...state, dispatch }}>
      {!state.isLoading && <AxiosInterceptor>{children}</AxiosInterceptor>}
    </UserContext.Provider>
  );
};

export const useUserInfo = () => useContext(UserContext);
